import { useEffect, useRef } from 'react';

export function useLastDefined<T>(value: T | undefined): T | undefined {
  const cacheRef = useRef(value);
  useEffect(() => {
    if (value !== undefined) {
      cacheRef.current = value;
    }
  }, [value]);
  return value !== undefined ? value : cacheRef.current;
}
